<template>
  <page :loading='pageLoading'>
    <template #content>
      <SubTopBar/>
      <v-breadcrumbs
        :items="bcItems"
        divider=">"
        large
        />
        <v-form v-model="valid" ref="form">
        <v-row>
          <v-col cols="12">
            <v-select
              outlined
              dense
              :items="labels"
              :rules="[global.rules.requiredField]"
              label="Label"
              v-model="label"
              :disabled="verify"
            />
          </v-col>
          <v-col cols="12" v-if="!showPhoneVerification">
            <vue-tel-input-vuetify 
            label="Phone number"
            v-model="phonenumber"
            outlined
            placeholder=""
            dense
            @input="onInput"
            :disabled="verify"
            :rules="[global.rules.requiredField]"/>
          </v-col>
          <v-col cols="7" v-if="showPhoneVerification">
            <vue-tel-input-vuetify 
            label="Phone number"
            v-model="phonenumber"
            outlined
            placeholder=""
            dense
            @input="onInput"
            :disabled="verify"
            :rules="[global.rules.requiredField]"/>
          </v-col>
          <v-col cols="5" v-if="showPhoneVerification">
            <v-text-field
              label="Verification code *"
              style="height:40px"
              outlined
              dense
              v-model="smscode"
              @keydown="restrictNumeric"
              @paste="noPaste"
              ref="verificationCode"
              append-icon="mdi-help-circle-outline"/>
            <v-btn class="ml-0 mt-n1" text x-small @click="validate">Resend code</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-btn color="primary" v-if="verify" disabled>Add phone number</v-btn>
          <v-btn color="primary" @click="registerNewPhoneNumber" v-if="!verify" :disabled="!valid">Add phone number</v-btn>
          <v-btn text @click="close">cancel</v-btn>
        </v-row>
      </v-form>
    </template>
  </page>
</template>

<script>
import AddPhoneStrings from "./AddPhoneStrings.js"
const Iam = require('iam')
import { VueTelInputVuetify } from 'vue-tel-input-vuetify'
export default {
  components: {
    VueTelInputVuetify
  },
  data () {
    return {
      showPhoneVerification: false,
      pageLoading: true,
      labels: [ 'Personal', 'Work', 'Home', 'Spam' ],
      phonenumber: "",
      validatedPhonenumber: "",
      smscode: "",
      label: "",
      validationkey: null,
      valid: true,
 
    }
  },
  created: function () {
    const label = this.$route.params.label
    if ( label ) {
      this.$api.getUserPhonenumberByLabel(label, this.username, this.callBack(
        response => {
          this.label = response.label
          this.phonenumber = response.phonenumber
          this.$nextTick(() => this.validate()) 
        }, () => {
          this.alert("error", AddPhoneStrings(this, "something_went_wrong"), undefined, undefined, this.close)
        }, ()=> {
          this.pageLoading = false
        }))
    } else {
      this.$api.getUserPhoneNumbers(this.username, [], this.callBack(
        response => {
          response.forEach((item) => {
            const index = this.labels.indexOf(item.label)
            if (index > -1) this.labels.splice(index, 1)
          })
        }, () => {
          this.alert("error", AddPhoneStrings(this, "something_went_wrong"), undefined, undefined, this.close)
        }, ()=> {
          this.pageLoading = false
        }))
    }
    
  },
  computed: {
    verify: function () { return "undefined" !== typeof this.$route.params.label },
    bcItems: function (){
      return [
        {},
        {
          text: "Profile",
          disabled: false,
          exact: true,
          to: {name: 'Profile'},
        },
        {
          text: "Phone numers",
          disabled: false,
          exact: true,
          to: {name: "PhoneNumbers"},
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]}
  },
  watch: {
    smscode: function () {
      if (this.smscode.length == 6) {
        const verify = new Iam.VerifyPhoneNumber()
        verify.smscode = this.smscode
        verify.validationkey = this.validationkey
        this.$api.verifyPhoneNumber(verify, this.label, this.username, this.callBack(
          this.close,
          error => {
            if (error.status == 422) {
              this.alert("error", AddPhoneStrings(this, "invalid_code"), undefined, undefined, () => {
                this.smscode = ""
                this.$refs.verificationCode.focus()
              })
            }
          }
        ))
      }
    },
  },
  methods: {
    onInput(formattedNumber, { number}) {
      this.phonenumber = number.international
      
    },
    registerNewPhoneNumber() {
      if (!this.$refs.form.validate()) return
      const phone = new Iam.Phonenumber()
      phone.phonenumber = this.phonenumber
      phone.label = this.label
      this.$api.registerNewUserPhonenumber(phone, this.username, this.callBack(
        response => {
          if (response && !response.validated) {
            this.validationkey = response.validationkey
            this.$router.replace({
              name: "VerifyPhoneNumber",
              params: { label: this.label },
            })
            this.showPhoneVerification = true
            this.alert(
              "info",
              AddPhoneStrings(this, "validate_number"),
              undefined,
              undefined,
              () => {
                this.$refs.verificationCode.focus()
              }
            )
            this.validatedPhonenumber = this.phonenumber
          }
          else {
            this.close()
          }
        },
        error => {
          if (error.status == 400) {
            this.alert("error", AddPhoneStrings(this, "invalid_input"))
          } else if (error.status == 409) {
            this.alert("error", AddPhoneStrings(this, "something_went_wrong"))
          } else {
            this.alert("error", AddPhoneStrings(this, "something_went_wrong"))
          }
        }
      ))},
    validate() {
      this.$api.validatePhonenumber(this.label, this.username, this.callBack(
        response => {
          this.showPhoneVerification = true
          this.validationkey = response.validationkey
          this.alert("info", AddPhoneStrings(this, "validate_number"), undefined, undefined, () => {
            this.$refs.verificationCode.focus()
          })
          this.validatedPhonenumber = this.phonenumber
        }
      ))
      
    },
    reset () {
      this.$refs.form.reset()
    }
  },
}
</script>